<template>
    <!-- 标签栏 -->
    <div ref="scrollCon" @DOMMouseScroll="handleScroll" @mousewheel="handleScroll" class="tags-outer-scroll-con">
        <!-- 右边那个操作用的按钮 -->
        <div class="close-all-tag-con">
            <Dropdown transfer @on-click="handleOptions">
                <Button size="small" type="primary">
                    标签选项
                    <Icon type="arrow-down-b"></Icon>
                </Button>
                <DropdownMenu slot="list">
                    <DropdownItem name="clear_all">关闭所有</DropdownItem>
                    <DropdownItem name="clear_other">关闭其他</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <!-- 左侧可以滚动的区域 -->
        <div ref="scrollBody" class="tags-inner-scroll-body" :style="{left: tagBodyLeft + 'px'}">
            <transition-group name="taglist-moving-animation">
                <Tag type="dot" 
                    @click.native="changeTag(item)"
                    @on-close="closeTag(item)" 
                    v-for="item in tags" 
                    :key="item.id" 
                    :closable ="item.close"
                    :color="item.active===true?'primary':'default'"
                    ref="TagList">{{item.title}}
                </Tag>
                    

            </transition-group>
        </div>
    </div>
</template>

<script>
import {mixins} from './tags'
export default {
    mixins:[mixins],
}
</script>